import RequestStatus from "../model/RequestStatus";
import { GetProgramMetadataResponse } from "../model/ProgramMetadata";
import {
    PROGRAM_METADATA_QUERY_START,
    PROGRAM_METADATA_QUERY_SUCCESS,
    PROGRAM_METADATA_QUERY_FAILED,
    GetProgramMetadataQueryComplete
} from "../actions/ProgramMetadataAction";

const initialState: GetProgramMetadataResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    data: null,
};

export default (
    state: GetProgramMetadataResponse = initialState,
    action: GetProgramMetadataQueryComplete
): GetProgramMetadataResponse => {
    switch (action.type) {
        case PROGRAM_METADATA_QUERY_START:
            return {
                requestStatus: RequestStatus.LOADING,
                data: null,
            };
        case PROGRAM_METADATA_QUERY_SUCCESS:
            return {
                requestStatus: RequestStatus.SUCCESS,
                data: action.programMetadata,
            };
        case PROGRAM_METADATA_QUERY_FAILED:
            return {
                requestStatus: RequestStatus.ERROR,
                data: null,
            };
        default:
            return state;
    }
};
